// Profile — 표시 포맷 헬퍼.
//
// Overview(overview/format.ts)의 PLATFORM_LABEL·formatCount·formatYearMonth는 그대로 재사용하고,
// Profile 목업이 요구하는 "전체 자릿수(콤마)" 표기와 빈 값 가드(—)만 여기서 보강한다.
//   · 채널 규모 테이블/합계·대표 콘텐츠 조회수 = 콤마 전체 자릿수(만/억 축약 아님).
//   · 빈 문자열/null = "—" (실데이터 철칙: 임의 채우기 금지).
import type { Platform } from '../../creatorsApi'

/** 소셜네임 표시 포맷 — DB(social_name)엔 @ 없이 저장되므로 표시 레이어에서 붙인다.
 *  IG/TikTok = 핸들이라 @ 프리픽스(이미 @면 중복 방지) · YouTube = 채널명이라 그대로.
 *  값 없으면 빈 문자열(호출측에서 폴백). */
export function formatHandle(platform: Platform, name: string | null | undefined): string {
  const s = name?.trim()
  if (!s) return ''
  if (platform === 'youtube') return s
  return s.startsWith('@') ? s : `@${s}`
}

/** 정수 전체 자릿수 콤마 표기. null/비유한값 → "—". (채널 규모·조회수) */
export function formatInt(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—'
  return Math.round(n).toLocaleString('ko-KR')
}

/** 문자열 값 가드 — 비어있으면 "—". */
export function orDash(v: string | null | undefined): string {
  const s = v?.trim()
  return s ? s : '—'
}
